"use client";
import { useMemo } from "react";
import { useContainerBreakpoints } from "../../../hooks/index.js";
import { HERO_CAROUSEL_BREAKPOINT_OPTIONS } from "./hero.constants.js";
function useHeroArrowPlacement({ showArrowBtns, isTouchDevice }) {
    const { containerRef, heroWide, '3xl': isContainer3xl } = useContainerBreakpoints(HERO_CAROUSEL_BREAKPOINT_OPTIONS);
    const arrowPlacement = useMemo(()=>{
        if (!showArrowBtns || isTouchDevice) return 'hidden';
        if (heroWide) return 'side';
        if (isContainer3xl) return 'bottomRow';
        return 'hidden';
    }, [
        showArrowBtns,
        isTouchDevice,
        heroWide,
        isContainer3xl
    ]);
    const arrowIconButtonProps = useMemo(()=>({
            size: heroWide ? 'md' : 'xs',
            shadow: true
        }), [
        heroWide
    ]);
    return {
        containerRef,
        arrowPlacement,
        arrowIconButtonProps
    };
}
export { useHeroArrowPlacement };
